import { FC } from 'react';
import styled from 'styled-components';
import { RoundedImageProps } from '../atoms/rounded-image';
import { useAuthor } from '../hooks/use-author';
import { AuthorName, AuthorNameWithoutLink } from './author-name';
import { AuthorImage } from './author-image';

const Container = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  ${({ theme }): string => theme.mixins.margin({ bottom: 1, right: 2 })};
`;

type AuthorProps = RoundedImageProps & {
  author: string;
  nameLink: boolean;
};

export const Author: FC<AuthorProps> = ({ author, nameLink, $size }) => {
  const authorData = useAuthor(author);

  return authorData.active ? (
    <Container>
      {authorData.authorImage && <AuthorImage $size={$size} image={authorData.authorImage} alt={author} />}
      {nameLink ? (
        <AuthorName to={authorData.authorLink}>{authorData.authorName}</AuthorName>
      ) : (
        <AuthorNameWithoutLink>{authorData.authorName}</AuthorNameWithoutLink>
      )}
    </Container>
  ) : null;
};
